var _path, _path2, _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _g5, _circle6, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdventurousGauge = function SvgAdventurousGauge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 91,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#adventurous-gauge_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2D2C",
    d: "m13.537 79.563-.828-2.106H7.525l-.81 2.106h-3.24l5.202-12.24h2.916l5.184 12.24zm-5.022-4.645h3.204l-1.602-4.122zm15.13-8.136h2.916v12.78h-2.916v-.431c-.648.413-1.422.665-2.394.665-2.358 0-4.338-1.98-4.338-4.59 0-2.591 1.98-4.571 4.338-4.571.972 0 1.746.251 2.394.683zm-1.8 10.567c.63 0 1.242-.163 1.8-.775v-2.7c-.558-.611-1.17-.773-1.8-.773-1.188 0-2.07.918-2.07 2.106 0 1.224.882 2.142 2.07 2.142m12.912-6.517h3.078l-3.78 8.73h-2.772l-3.78-8.73h3.078l2.088 5.04zm7.681-.233c3.078 0 4.932 2.195 4.5 5.291H40.62c.198.9.792 1.603 1.98 1.603.648 0 1.026-.144 1.296-.468h2.952c-.522 1.71-2.142 2.771-4.194 2.771-2.862 0-4.77-1.944-4.77-4.608 0-2.645 1.854-4.59 4.554-4.59m.072 2.16c-1.026 0-1.62.576-1.854 1.457h3.636c-.162-1.007-.792-1.457-1.782-1.457m11.276-2.16c2.196 0 3.708 1.493 3.708 3.977v4.987h-2.916v-4.519c0-1.242-.63-1.8-1.602-1.8-.522 0-1.08.27-1.584.829v5.49h-2.934v-8.73h2.934v.576c.702-.523 1.458-.81 2.394-.81m12.143 6.155.324 2.61c-.9.379-1.836.432-2.34.432-2.376 0-3.816-1.547-3.816-3.906v-2.555h-1.71v-2.502h1.71v-2.97h2.916v2.97h2.97v2.502h-2.97V75.8c0 .9.522 1.314 1.368 1.314.558 0 1.026-.162 1.548-.36m7.789-5.922h2.916v8.73h-2.916v-.611c-.702.54-1.458.846-2.394.846-2.214 0-3.726-1.53-3.726-4.014v-4.95h2.916v4.5c0 1.242.648 1.835 1.602 1.835.54 0 1.098-.306 1.602-.864zm10.844-.143v2.772c-1.422.053-2.322.431-3.006 1.097v5.004h-2.934v-8.73h2.934v.937c.774-.666 1.71-1.08 3.006-1.08m5.589-.09c2.808 0 4.788 1.925 4.788 4.608 0 2.7-1.98 4.59-4.788 4.59s-4.806-1.89-4.806-4.59c0-2.682 1.998-4.608 4.806-4.608m0 6.767c1.206 0 2.052-.882 2.052-2.16 0-1.26-.846-2.16-2.052-2.16-1.224 0-2.07.9-2.07 2.16 0 1.278.846 2.16 2.07 2.16m12.289-6.534h2.916v8.73h-2.916v-.611c-.702.54-1.458.846-2.394.846-2.214 0-3.726-1.53-3.726-4.014v-4.95h2.917v4.5c0 1.242.648 1.835 1.601 1.835.54 0 1.098-.306 1.602-.864zm6.902 5.743c.126.755.81 1.08 1.728 1.08.774 0 1.26-.216 1.26-.594 0-.307-.342-.523-.918-.613l-1.764-.305c-1.494-.252-2.556-1.099-2.556-2.629 0-1.835 1.566-2.915 3.888-2.915 2.07 0 3.942.701 4.068 3.005h-2.574c-.054-.647-.684-.936-1.494-.936-.756 0-1.098.27-1.098.594 0 .306.216.576.918.703l1.62.27c1.62.305 2.718 1.097 2.718 2.645 0 2.017-1.8 2.916-4.086 2.916-2.25 0-4.104-.918-4.302-3.24z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "adventurous-gauge_svg__b",
    width: 118,
    height: 58,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.645.395h116.38v57.151H.645z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#adventurous-gauge_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "adventurous-gauge_svg__c",
    width: 118,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.175,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#adventurous-gauge_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA8B8",
    stroke: "#FFA8B8",
    d: "m53.76 53.363 3.41-1.2L40.244 2.607l-18.338 8.976-10.633 13.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "adventurous-gauge_svg__d",
    width: 118,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.175,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#adventurous-gauge_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FD8FA4",
    stroke: "#FD8FA4",
    d: "M57.12 50.255 40.226.278l18.402-4.253L77.71-.162l-16.43 50.67z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "adventurous-gauge_svg__e",
    width: 118,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.175,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#adventurous-gauge_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D93657",
    stroke: "#D93657",
    d: "M106.952 23.21 68.34 49.585l3.868 7.525h46.347l-3.586-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "adventurous-gauge_svg__f",
    width: 118,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.175,
    r: 57.69,
    fill: "#D9D9D9",
    stroke: "#FDEFE0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#adventurous-gauge_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE1E7",
    stroke: "#FFE1E7",
    d: "m10.716 23.21 38.612 26.375-3.868 7.525H-.887l3.586-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "adventurous-gauge_svg__g",
    width: 118,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.175,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#adventurous-gauge_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC6481",
    stroke: "#FC6481",
    d: "m65.199 51.96-3.43-1.143L77.872.985l18.484 8.672 10.862 13.72z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.833,
    cy: 59.182,
    r: 26.263,
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m73.41 56.297 3.767-3.865-3.955-3.854M59.18 52.437l16.5-.007"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "adventurous-gauge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .395h118v90H0z"
  })))));
};
export { SvgAdventurousGauge as ReactComponent };
export default __webpack_public_path__ + "images/adventurous-gauge.svg";